import { cipo } from 'cipo';

cipo.controller('idpController',
    function ($scope, $state, Message)
    {
    });